module.exports = __webpack_public_path__ + "media/images/app/products/index/banner-all-mobile-d8b1bfce96c35181deeb73b53c1ac79f.webp";